import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { PatchDealerRequest } from "hooks/useDealers";
import {
  SectionTitle,
  EditFormGrid,
  FormField,
  FormLabel,
  FormActions,
} from "styles/components/userDetails.styles";

interface Props {
  form: PatchDealerRequest;
  isSaving: boolean;
  onChange: (updated: PatchDealerRequest) => void;
  onSave: () => void;
}

const DealerEditTab: React.FC<Props> = ({
  form,
  isSaving,
  onChange,
  onSave,
}) => {
  const set = (patch: Partial<PatchDealerRequest>) =>
    onChange({ ...form, ...patch });

  return (
    <div style={{ marginTop: "1rem" }}>
      <SectionTitle>
        <i className="pi pi-user-edit" />
        Edit Dealer Details
      </SectionTitle>

      <EditFormGrid>
        <FormField>
          <FormLabel htmlFor="edit-firstName">First Name</FormLabel>
          <InputText
            id="edit-firstName"
            value={form.firstName ?? ""}
            onChange={(e) => set({ firstName: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-lastName">Last Name</FormLabel>
          <InputText
            id="edit-lastName"
            value={form.lastName ?? ""}
            onChange={(e) => set({ lastName: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-email">Email</FormLabel>
          <InputText
            id="edit-email"
            value={form.email ?? ""}
            onChange={(e) => set({ email: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-phone">Phone</FormLabel>
          <InputText
            id="edit-phone"
            value={form.phone ?? ""}
            onChange={(e) => set({ phone: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-dealerName">Dealer Name</FormLabel>
          <InputText
            id="edit-dealerName"
            value={form.dealerName ?? ""}
            onChange={(e) => set({ dealerName: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-city">City</FormLabel>
          <InputText
            id="edit-city"
            value={form.city ?? ""}
            onChange={(e) => set({ city: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-country">Country</FormLabel>
          <InputText
            id="edit-country"
            value={form.country ?? ""}
            onChange={(e) => set({ country: e.target.value })}
          />
        </FormField>
        <FormField>
          <FormLabel htmlFor="edit-language">Language</FormLabel>
          <InputText
            id="edit-language"
            value={form.language ?? ""}
            onChange={(e) => set({ language: e.target.value })}
          />
        </FormField>
      </EditFormGrid>

      <FormActions>
        <Button
          label="Save Changes"
          icon="pi pi-save"
          onClick={onSave}
          loading={isSaving}
        />
      </FormActions>
    </div>
  );
};

export default DealerEditTab;
